/* Evelyn's Herbal Co. — behaviour layer for the Shopify migration.
   Rebuilds the interactions the Next.js app provided client-side. */
(function () {
  'use strict';

  var SEL = {
    selectedBtn: 'border-[#315d3e] bg-[#fffdf8] shadow-[0_22px_60px_-45px_rgba(36,49,40,0.7)]',
    idleBtn: 'border-[#6e947a]/25 bg-[#fffdf8]/70 hover:border-[#6e947a]/50',
    selectedDot: 'border-[#315d3e] bg-[#315d3e]',
    idleDot: 'border-[#6e947a]/50'
  };
  var CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check h-3 w-3 text-[#fffdf8]" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function swap(el, remove, add) {
    remove.split(' ').forEach(function (c) { if (c) el.classList.remove(c); });
    add.split(' ').forEach(function (c) { if (c) el.classList.add(c); });
  }

  /* ---------------- announcement countdown ---------------- */
  function countdown() {
    var nodes = $$('[data-countdown]'), parts = { h: $$('[data-cd="h"]'), m: $$('[data-cd="m"]'), s: $$('[data-cd="s"]') };
    if (!nodes.length && !parts.h.length) return;
    /* Match Amboras: one 37:22 countdown per tab session, then its final-chance message. */
    var KEY = 'evelyns_sale_deadline:session:v1', DUR = 2242 * 1000, now = Date.now(), deadline = now + DUR, expired = false, interval;
    try {
      var stored = sessionStorage.getItem(KEY), saved = Number(stored);
      if (stored === 'expired') expired = true;
      else if (Number.isFinite(saved) && saved > 0 && saved - now <= DUR) {
        if (saved > now) deadline = saved;
        else expired = true;
      }
      sessionStorage.setItem(KEY, expired ? 'expired' : String(deadline));
    } catch (x) {}
    function finish() {
      expired = true;
      try { sessionStorage.setItem(KEY, 'expired'); } catch (x) {}
      $$('[data-sale-timer]').forEach(function (n) { n.hidden = true; n.style.display = 'none'; });
      $$('[data-sale-ended]').forEach(function (n) { n.hidden = false; });
      if (interval) clearInterval(interval);
    }
    function tick() {
      if (expired || deadline <= Date.now()) { finish(); return; }
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      var t = [Math.floor(s / 3600), Math.floor(s / 60) % 60, s % 60]
        .map(function (n) { return String(n).padStart(2, '0'); }).join(':');
      nodes.forEach(function (n) { n.textContent = t; });
      var p = t.split(':');
      parts.h.forEach(function (n) { n.textContent = p[0]; });
      parts.m.forEach(function (n) { n.textContent = p[1]; });
      parts.s.forEach(function (n) { n.textContent = p[2]; });
    }
    tick(); if (!expired) interval = setInterval(tick, 1000);
  }

  function headerScroll() {
    var header = $('header.sticky');
    if (!header) return;
    function paint() {
      var scrolled = window.scrollY > 10;
      swap(header,
        scrolled ? 'border-border/70 bg-background/92 backdrop-blur-sm' : 'border-border/80 bg-background/95 shadow-sm backdrop-blur-md',
        scrolled ? 'border-border/80 bg-background/95 shadow-sm backdrop-blur-md' : 'border-border/70 bg-background/92 backdrop-blur-sm');
    }
    window.addEventListener('scroll', paint, { passive: true });
    paint();
  }

  /* ---------------- mobile menu ---------------- */
  function mobileMenu() {
    var panel = $('[data-mobile-menu]'); if (!panel) return;
    var openers = $$('[data-menu-open]'), focusBefore;
    function open(value) {
      if (value) focusBefore = document.activeElement;
      panel.classList.toggle('hidden', !value); panel.setAttribute('aria-hidden', String(!value));
      openers.forEach(function (button) { button.setAttribute('aria-expanded', String(value)); });
      document.documentElement.style.overflow = value ? 'hidden' : '';
      if (value) { var first = panel.querySelector('button, a[href]'); if (first) first.focus(); }
      else if (focusBefore && focusBefore.isConnected) focusBefore.focus();
    }
    openers.forEach(function (button) { button.addEventListener('click', function () { open(true); }); });
    $$('[data-menu-close]').forEach(function (button) { button.addEventListener('click', function () { open(false); }); });
    document.addEventListener('keydown', function (event) {
      if (panel.classList.contains('hidden')) return;
      if (event.key === 'Escape') { event.preventDefault(); open(false); return; }
      if (event.key !== 'Tab') return;
      var items = $$('button:not([disabled]), a[href], [tabindex="0"]', panel).filter(function (el) { return el.offsetParent !== null; });
      var first = items[0], last = items[items.length - 1]; if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
  }
var GIFT_RULES = {
    "56340974174500": ["56340999504164"],                     // Roll-On x1  -> Usage Guide
    "56340974207268": ["56340999504164"],                     // Roll-On x3  -> Usage Guide
    "56340974240036": ["56340999504164","56340982661412"],    // Roll-On x5  -> Usage Guide + 30-Day Reset
    "56340991148324": ["56340999504164"],                     // UBF Roll-On x1 -> Belly Guide
    "56340991181092": ["56340999504164"],                     // UBF Roll-On x3 -> Belly Guide
    "56340991213860": ["56340999504164","56340982661412"],    // UBF Roll-On x5 -> Belly Guide + Reset
  };
  /* Single-variant products sold in packs by quantity: [min quantity, gifts] tiers by handle.
     Irritation Relief Cream: 1+ = Full Cream Usage Guide, 5+ = also 14-Day Irritation Relief Plan (as on Amboras). */
  var QTY_GIFTS = {
    "relief-cream": [[1, ["67565209223460"]], [5, ["67662223671588"]]],
    "soap": [[1, ["56340982497572"]], [5, ["67627469537572"]]]
  };
  /* Products that count together toward a quantity tier (bar + belly-fold soap). */
  var QTY_GROUP = {
    "relief-cream": "relief-cream",
    "evelyns-herbal-co-antifungal-soap-bar": "soap",
    "evelyns-herbal-co-antifungal-soap-under-belly-fold": "soap"
  };
  var ALL_GIFTS = ["67662223671588","67627469537572","67565209223460","56340999504164","56340982661412","56340982497572","56340999602468","56340982563108"];
  var CREAM_GIFTS = ["67565209223460","67662223671588"];

  /* ---------------- cream: Buy 2 Get 1 Free in the bag (as on Amboras) ----------------
     The cream is one variant, so paid and free creams share one line; the automatic
     "Cream N-pack" discounts make each step cost what Amboras charges (the current source offer totals).
     Every 3 paid creams add 2 free, and 2 paid left over add 1 more:
     1 paid = 1 cream, 2 = 3, 3 = 5 (the 5-cream card, $69.90), 4 = 6, 5 = 8, 6 = 10. */
  var CREAM_HANDLE = 'relief-cream', CREAM_MAX_PAID = 6;
  function creamFree(p) { return p >= 2 ? 2 * Math.floor(p / 3) + (p % 3 === 2 ? 1 : 0) : 0; }
  function creamTotal(p) { return p + creamFree(p); }
  function creamPaid(n) { var p = 0; while (creamTotal(p) < n) p++; return p; }
  /* Rounds the cream line up to the next step, e.g. 1 cream + 1 cream = 2 paid + 1 free. */
  function normalizeCream(cart) {
    var line = 0, it = null;
    cart.items.forEach(function (x, i) { if (!it && x.handle === CREAM_HANDLE) { it = x; line = i + 1; } });
    if (!it || creamTotal(creamPaid(it.quantity)) === it.quantity) return Promise.resolve(cart);
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: creamTotal(creamPaid(it.quantity)) })
    }).then(function (r) { return r.json(); }).catch(function () { return cart; });
  }

  var SKIN_PLANS = ['67627469537572', '56340982661412'];
  var PACK_UNITS = { '56340974174500': 1, '56340974207268': 3, '56340974240036': 5, '56340991148324': 1, '56340991181092': 3, '56340991213860': 5 };
  function eligibleGifts(cart) {
    var want = {}, units = {}, cream = 0;
    cart.items.forEach(function (it) {
      var id = String(it.variant_id), rule = GIFT_RULES[id];
      if (rule) rule.forEach(function (gift) { if (SKIN_PLANS.indexOf(gift) === -1) want[gift] = true; });
      if (it.handle === CREAM_HANDLE) cream += it.quantity;
      if (QTY_GROUP[it.handle] === 'soap' || PACK_UNITS[id]) {
        var key = it.product_id || it.handle;
        units[key] = (units[key] || 0) + (PACK_UNITS[id] || 1) * it.quantity;
        if (QTY_GROUP[it.handle] === 'soap') want['56340982497572'] = true;
      }
    });
    if (cream >= 1) want['67565209223460'] = true;
    if (cream >= 5) want['67662223671588'] = true;
    if (Object.keys(units).some(function (key) { return units[key] >= 5; })) {
      /* The source has one plan for soaps and roll-ons. Retain an existing native
         equivalent, and never issue two plans for a mixed cart. */
      var existing = cart.items.filter(function (it) { return SKIN_PLANS.indexOf(String(it.variant_id)) !== -1; })[0];
      want[existing ? String(existing.variant_id) : '56340982661412'] = true;
    }
    return want;
  }
  function activeDeclines(cart) {
    var eligible = eligibleGifts(cart);
    return declinedGifts(cart).filter(function (id) {
      return SKIN_PLANS.indexOf(id) !== -1 ? SKIN_PLANS.some(function (plan) { return eligible[plan]; }) : eligible[id];
    });
  }
  function giftsFor(cart) {
    var want = eligibleGifts(cart);
    activeDeclines(cart).forEach(function (id) {
      if (SKIN_PLANS.indexOf(id) !== -1) SKIN_PLANS.forEach(function (plan) { delete want[plan]; });
      else delete want[id];
    });
    return want;
  }

  /* Keep a shopper's removed gifts removed for this cart, as on Amboras. */
  var DECLINED_GIFTS = 'evelyns_declined_gifts';
  function declinedGifts(cart) {
    try {
      var ids = JSON.parse((cart.attributes || {})[DECLINED_GIFTS] || '[]');
      return Array.isArray(ids) ? ids.filter(function (id) { return ALL_GIFTS.indexOf(String(id)) !== -1; }).map(String) : [];
    } catch (error) { return []; }
  }
  var lastCart = null, cartQueue = Promise.resolve(), pendingAdds = 0;
  /* Keep startup reads, additions and quantity changes in order. An older empty
     response must never replace the result of a newer Add to cart. */
  function queueCart(task) {
    var request = cartQueue.then(task);
    cartQueue = request.catch(function () {});
    return request;
  }
  function readCart() {
    return fetch('/cart.js').then(function (response) {
      if (!response.ok) throw new Error('Could not load cart');
      return response.json();
    });
  }
  function addCartItems(items, isCream) {
    pendingAdds += 1;
    var request = queueCart(function () {
      var additions = items.slice();
      var beforeQuantities = {};
      if (lastCart) lastCart.items.forEach(function (item) {
        var id = String(item.variant_id);
        beforeQuantities[id] = (beforeQuantities[id] || 0) + item.quantity;
      });
      /* Cream gifts can travel with the creams in one request. The queued
         startup read supplies the existing cart and any declined gifts. */
      if (isCream && lastCart) {
        var projected = { attributes: lastCart.attributes, items: lastCart.items.map(function (item) {
          return Object.assign({}, item);
        }) };
        items.forEach(function (item) {
          var existing = projected.items.filter(function (line) { return String(line.variant_id) === String(item.id); })[0];
          if (existing) existing.quantity += item.quantity;
          else projected.items.push({ variant_id: item.id, handle: CREAM_HANDLE, quantity: item.quantity });
        });
        var wanted = giftsFor(projected);
        Object.keys(wanted).forEach(function (id) {
          if (!projected.items.some(function (item) { return String(item.variant_id) === id; })) {
            additions.push({ id: Number(id), quantity: 1 });
          }
        });
      }
      function add(lines) {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: lines })
        });
      }
      return add(additions).then(function (response) {
        if (response.ok) return response;
        if (additions.length === items.length) throw new Error('Could not add item');
        /* If a bonus is unavailable, recover the paid addition without adding
           it twice: Shopify can leave partially added quantities after errors. */
        return readCart().then(function (cart) {
          var current = {};
          cart.items.forEach(function (item) {
            var id = String(item.variant_id);
            current[id] = (current[id] || 0) + item.quantity;
          });
          var remaining = items.map(function (item) {
            var id = String(item.id);
            return { id: item.id, quantity: Math.max(0, (beforeQuantities[id] || 0) + item.quantity - (current[id] || 0)) };
          }).filter(function (item) { return item.quantity > 0; });
          return remaining.length ? add(remaining) : { ok: true, json: function () { return Promise.resolve(cart); } };
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not add item');
        return response.json();
      }).then(readCart).then(normalizeCream).then(reconcileGifts).then(function (cart) {
        renderCart(cart);
        return cart;
      });
    });
    return request.then(function (cart) {
      pendingAdds -= 1;
      return cart;
    }, function (error) {
      pendingAdds -= 1;
      if (cartIsOpen()) {
        if (lastCart) renderCart(lastCart);
        else cartLoadFailed();
      }
      throw error;
    });
  }
  window.evhAddToCart = addCartItems;
  function declineGift(id) {
    if (ALL_GIFTS.indexOf(String(id)) === -1 || !lastCart) return;
    var ids = declinedGifts(lastCart);
    if (ids.indexOf(String(id)) === -1) ids.push(String(id));
    var attributes = {}, updates = {};
    attributes[DECLINED_GIFTS] = JSON.stringify(ids); updates[id] = 0;
    mutate(function () {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attributes, updates: updates }) });
    });
  }

  /* Adds missing gifts and strips gifts that no longer qualify. Returns a promise
     that resolves with the final cart. */
  function reconcileGifts(cart) {
    var want = giftsFor(cart);
    var present = {};
    cart.items.forEach(function (it) {
      if (ALL_GIFTS.indexOf(String(it.variant_id)) !== -1) present[String(it.variant_id)] = it;
    });

    var toAdd = Object.keys(want).filter(function (g) { return !present[g]; });
    var toDrop = Object.keys(present).filter(function (g) { return !want[g]; });
    var toFix = Object.keys(present).filter(function (g) { return want[g] && present[g].quantity !== 1; });

    var declined = activeDeclines(cart), resetDeclines = JSON.stringify(declined) !== JSON.stringify(declinedGifts(cart));
    if (!toAdd.length && !toDrop.length && !toFix.length && !resetDeclines) return Promise.resolve(cart);

    var chain = Promise.resolve();
    if (resetDeclines) {
      chain = chain.then(function () {
        var attributes = {}; attributes[DECLINED_GIFTS] = JSON.stringify(declined);
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attributes }) });
      });
    }
    if (toAdd.length) {
      chain = chain.then(function () {
        return fetch("/cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: toAdd.map(function (g) { return { id: Number(g), quantity: 1 }; }) })
        });
      });
    }
    toFix.forEach(function (g) {
      chain = chain.then(function () {
        var u = {}; u[g] = 1;
        return fetch("/cart/update.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: u })
        });
      });
    });
    toDrop.forEach(function (g) {
      chain = chain.then(function () {
        var u = {}; u[g] = 0;
        return fetch("/cart/update.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: u })
        });
      });
    });
    return chain.then(function () { return fetch("/cart.js"); })
                .then(function (r) { return r.json(); })
                .catch(function () { return cart; });
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = null;
  function cartDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) {
      if (!cartIsOpen()) return;
      if (e.key === 'Escape') { closeCart(); return; }
      if (e.key !== 'Tab') return;
      var box = drawer.querySelector('[role="dialog"]') || drawer;
      var f = Array.prototype.filter.call(box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !box.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !box.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    drawer.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-line-dec]'), inc = e.target.closest('[data-line-inc]'), rm = e.target.closest('[data-line-remove]');
      if (dec) changeLine(dec.dataset.lineDec, +dec.dataset.qty - 1);
      if (inc) changeLine(inc.dataset.lineInc, +inc.dataset.qty + 1);
      if (rm) {
        if (rm.dataset.giftVariant) declineGift(rm.dataset.giftVariant);
        else changeLine(rm.dataset.lineRemove, 0);
      }
      var pinc = e.target.closest('[data-pouch-inc]'), pdec = e.target.closest('[data-pouch-dec]');
      if (pinc || pdec) setExtraPouches(+(pinc || pdec).dataset.extra + (pinc ? 1 : -1));
      /* Cream +/- steps the paid count; the free creams follow. */
      var cstep = e.target.closest('[data-cream-step]');
      if (cstep) {
        var paid = Math.min(CREAM_MAX_PAID, Math.max(1, creamPaid(+cstep.dataset.qty) + Number(cstep.dataset.creamStep)));
        changeLine(cstep.dataset.line, creamTotal(paid));
      }
    });
    setInterval(paintReservation, 1000);
  }

  /* ---------------- cart reservation (as on Amboras) ----------------
     "Your cart is reserved for 9:59 minutes" at the top of the bag: 10 minutes from the last
     Add to cart (or from the first time the bag shows items), kept for the browser tab. Once it
     runs out it stays hidden until the next Add to cart. */
  var RES_KEY = 'evh_cart_reserved_until', RES_MS = 600000, resEnd, resHasItems = false;
  function readReservation() {
    var now = Date.now();
    try {
      var v = sessionStorage.getItem(RES_KEY), n = Number(v);
      if (v === 'expired') return null;
      if (n > 0 && n <= now + RES_MS) {
        if (n > now) return n;
        sessionStorage.setItem(RES_KEY, 'expired'); return null;
      }
      sessionStorage.setItem(RES_KEY, String(now + RES_MS));
    } catch (x) {}
    return now + RES_MS;
  }
  function restartReservation() {
    resEnd = Date.now() + RES_MS;
    try { sessionStorage.setItem(RES_KEY, String(resEnd)); } catch (x) {}
    paintReservation();
  }
  window.evhRestartReservation = restartReservation;
  function paintReservation() {
    var bar = $('[data-cart-reservation]');
    if (!bar) return;
    if (resHasItems && resEnd === undefined) resEnd = readReservation();
    var left = resHasItems && resEnd ? resEnd - Date.now() : 0;
    if (resHasItems && resEnd && left <= 0) {
      resEnd = null;
      try { sessionStorage.setItem(RES_KEY, 'expired'); } catch (x) {}
    }
    if (left <= 0) { bar.classList.add('hidden'); return; }
    var s = Math.ceil(left / 1000), t = $('[data-cart-reservation-time]', bar);
    if (t) t.textContent = Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
    bar.classList.remove('hidden');
  }
  var cartReturnFocus = null;
  function cartIsOpen() { return !!drawer && !drawer.classList.contains('hidden'); }
  function cartLoading() {
    if (!drawer) return;
    drawer.setAttribute('aria-busy', 'true');
    ['[data-cart-empty]', '[data-cart-lines]', '[data-cart-footer]', '[data-free-shipping]'].forEach(function (selector) {
      var element = $(selector, drawer); if (element) element.classList.add('hidden');
    });
    var loading = $('[data-cart-loading]', drawer);
    if (loading) { loading.textContent = 'Loading your bag…'; loading.classList.remove('hidden'); }
  }
  function cartLoadFailed() {
    if (!drawer) return;
    drawer.removeAttribute('aria-busy');
    var loading = $('[data-cart-loading]', drawer);
    if (loading) { loading.textContent = 'Could not load your bag. Please close it and try again.'; loading.classList.remove('hidden'); }
  }
  function openCart(readyCart) {
    if (!drawer) return;
    if (readyCart) { if (readyCart !== lastCart) renderCart(readyCart); }
    else if (!lastCart || pendingAdds) cartLoading();
    else renderCart(lastCart);
    if (!cartIsOpen()) cartReturnFocus = document.activeElement;
    drawer.classList.remove('hidden'); document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('[role="dialog"] [data-cart-close]'); if (c) c.focus({ preventScroll: true });
    if (!readyCart) refreshCart().catch(cartLoadFailed);
  }
  window.evhOpenCart = openCart;
  function closeCart() {
    if (!cartIsOpen()) return;
    drawer.classList.add('hidden'); document.documentElement.style.overflow = '';
    if ($('[data-cart-page]')) { window.location.reload(); return; }
    if (cartReturnFocus && cartReturnFocus.focus && document.contains(cartReturnFocus)) cartReturnFocus.focus({ preventScroll: true });
    cartReturnFocus = null;
  }

  /* One cart update at a time; extra clicks while the cart is updating are ignored. */
  var busy = false;
  function mutate(req) {
    if (busy) return;
    busy = true;
    var lines = $('[data-cart-lines]'); if (lines) lines.style.opacity = '.55';
    queueCart(function () {
      return req().then(function (r) { if (!r.ok) throw new Error('Could not update cart'); return r.json(); })
        .then(normalizeCream).then(reconcileGifts).then(renderCart)
        .catch(function () { return readCart().then(renderCart); });
    }).then(function () { busy = false; if (lines) lines.style.opacity = ''; }, function () {
      busy = false; if (lines) lines.style.opacity = '';
    });
  }
  function changeLine(line, qty) {
    mutate(function () {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +line, quantity: Math.max(0, qty) }) });
    });
  }
  /* One cotton soap pouch is the free gift; each extra pouch is the paid "Extra Evelyn's™ Cotton Soap Pouch" ($3.99). */
  var FREE_POUCH = '56340982497572', EXTRA_POUCH = '67627540250916';
  function setExtraPouches(n) {
    var u = {}; u[EXTRA_POUCH] = Math.max(0, n);
    mutate(function () { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }); });
  }
  function refreshCart() {
    return queueCart(function () {
      return readCart().then(function (c) {
        return normalizeCream(c).then(reconcileGifts).then(function (f) { if (f !== c && $('[data-cart-page]')) window.location.reload(); return f; });
      }).then(function (cart) {
        if (pendingAdds && !cart.items.length) {
          lastCart = cart;
          if (cartIsOpen()) cartLoading();
        } else renderCart(cart);
        return cart;
      });
    });
  }

  function money(cents) {
    var f = window.Shopify && window.Shopify.money_format;
    var v = (cents / 100).toFixed(2);
    if (f) return f.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    return '$' + v;
  }

  var cartPriceCatalog = null;
  var GIFT_VALUES = {
    '67565209223460': 999, '56340999504164': 999,
    '67662223671588': 1499, '67627469537572': 1499, '56340982661412': 1499,
    '56340982497572': 399
  };
  function comparisonUnit(item) {
    if (!cartPriceCatalog) {
      var element = $('[data-cart-price-catalog]');
      try { cartPriceCatalog = element ? JSON.parse(element.textContent) : {}; }
      catch (error) { cartPriceCatalog = {}; }
    }
    var id = String(item.variant_id), catalog = cartPriceCatalog.variants || {};
    var native = catalog[id] || {};
    var regular = Math.max(Number(native.compare) || 0, Number(native.price) || 0, Number(item.original_price) || 0, Number(item.price) || 0);
    if (!regular && GIFT_VALUES[id]) {
      var rate = Number(cartPriceCatalog.giftRate) || (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
      regular = Math.round(GIFT_VALUES[id] * rate);
    }
    return regular;
  }
  function comparisonTotal(item) { return comparisonUnit(item) * item.quantity; }

  var ICON = {
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2 h-4 w-4" aria-hidden="true"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>',
    minus: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus h-3.5 w-3.5" aria-hidden="true"><path d="M5 12h14"></path></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus h-3.5 w-3.5" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>',
    truck: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck h-4 w-4 flex-shrink-0 text-primary" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-4 w-4 flex-shrink-0 text-primary" aria-hidden="true"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>'
  };

  function renderCart(cart) {
    lastCart = cart;
    document.dispatchEvent(new CustomEvent('evh:cart-updated', { detail: cart }));
    if (drawer) drawer.removeAttribute('aria-busy');
    var loading = $('[data-cart-loading]'); if (loading) loading.classList.add('hidden');
    $$('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.classList.toggle('hidden', cart.item_count === 0);
    });
    $$('[data-cart-count-text]').forEach(function (n) { n.textContent = cart.item_count; });
    $$('[data-cart-review-count]').forEach(function (n) {
      n.textContent = cart.items.some(function (it) { return it.handle === CREAM_HANDLE; }) ? '878' : '867';
    });
    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    $$('[data-cart-total]').forEach(function (n) { n.textContent = money(sub); });
    /* The footer uses the same regular totals as the crossed-out item prices. */
    var saved = 0;
    cart.items.forEach(function (it) {
      saved += Math.max(0, comparisonTotal(it) - it.final_line_price);
    });
    $$('[data-cart-discount]').forEach(function (n) { n.classList.toggle('hidden', saved <= 0); });
    $$('[data-cart-discount-value]').forEach(function (n) { n.textContent = '\u2212' + money(saved); });

    var lines = $('[data-cart-lines]'), empty = $('[data-cart-empty]'), foot = $('[data-cart-footer]'), ship = $('[data-free-shipping]');
    if (!lines) return;
    lines.classList.remove('hidden');

    resHasItems = cart.items.length > 0;
    paintReservation();
    if (!cart.items.length) {
      lines.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      if (foot) foot.classList.add('hidden');
      if (ship) ship.classList.add('hidden');
      return;
    }
    if (empty) empty.classList.add('hidden');
    if (foot) foot.classList.remove('hidden');

    /* free shipping meter */
    var drawer = $('[data-cart-drawer]');
    var threshold = Number((drawer && drawer.dataset.freeShippingThreshold) || 0) * 100;
    if (ship && threshold > 0) {
      ship.classList.remove('hidden');
      var remaining = Math.max(0, threshold - sub);
      var pct = Math.min(100, (sub / threshold) * 100);
      var icon = $('[data-ship-icon]'), txt = $('[data-ship-text]'), bar = $('[data-ship-bar]');
      if (icon) icon.innerHTML = remaining === 0 ? ICON.check : ICON.truck;
      if (txt) txt.innerHTML = remaining === 0
        ? '<span class="text-primary font-semibold">You&rsquo;ve unlocked free shipping</span>'
        : '<span>You&rsquo;re ' + money(remaining) + ' away from <span class="font-semibold">free shipping</span></span>';
      if (bar) bar.style.width = pct + '%';
    }

    var STEP = 'p-2.5 hover:bg-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
    function stepper(dec, inc, count, decOff, incOff) {
      return '<div class="flex items-center border rounded-md">' +
        '<button type="button" ' + dec + ' class="' + STEP + (decOff ? ' opacity-60 pointer-events-none' : '') + '"' + (decOff ? ' disabled' : '') + ' aria-label="Decrease quantity">' + ICON.minus + '</button>' +
        '<span class="px-3 text-sm font-medium tabular-nums w-8 text-center inline-flex items-center justify-center">' + count + '</span>' +
        '<button type="button" ' + inc + ' class="' + STEP + (incOff ? ' opacity-60 pointer-events-none' : '') + '"' + (incOff ? ' disabled' : '') + ' aria-label="Increase quantity">' + ICON.plus + '</button>' +
      '</div>';
    }
    function qtyNote(q) { return '<span class="px-1 text-xs text-muted-foreground">Quantity: ' + q + '</span>'; }
    var FREE_TAG = '<p class="mt-1 inline-flex items-center rounded-full bg-accent px-2 py-0.5 text-[11px] font-semibold text-accent-foreground">Free gift</p>';
    var FREE_PRICE = '<span class="uppercase tracking-wide text-primary">Free</span>';
    function row(it, o) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_220x$1$2') : '';
      var compare = o.compare != null ? o.compare : comparisonTotal(it);
      var current = o.current != null ? o.current : (o.free ? 0 : it.final_line_price);
      return '<div class="flex gap-4 transition-opacity">' +
        '<div class="relative h-28 w-[5.5rem] flex-shrink-0 overflow-hidden rounded bg-muted">' +
          (img ? '<img src="' + img + '" alt="" class="absolute inset-0 h-full w-full object-cover">' : '') +
        '</div>' +
        '<div class="flex flex-1 flex-col min-w-0">' +
          '<div class="flex justify-between gap-2">' +
            '<div class="min-w-0">' +
              '<h3 class="font-body font-medium text-sm truncate">' + it.product_title + '</h3>' +
              (it.variant_title && !/^\d+ Soaps?$/.test(it.variant_title) ? '<p class="text-xs text-muted-foreground mt-0.5">' + it.variant_title + '</p>' : '') +
              (o.free ? FREE_TAG : '') +
            '</div>' +
            (o.remove ? '<button type="button" data-line-remove="' + o.remove + '"' + (o.gift ? ' data-gift-variant="' + o.gift + '"' : '') + ' class="p-2 -mr-2 text-muted-foreground hover:text-foreground transition-colors flex-shrink-0" aria-label="Remove item">' + ICON.trash + '</button>' : '') +
          '</div>' +
          '<div class="mt-auto pt-2 flex items-center justify-between gap-2">' + o.qty +
            '<div class="text-sm font-medium text-right" style="display:flex;flex-direction:column;align-items:flex-end;gap:2px">' +
              (compare > current ? '<s data-cart-compare-total class="text-xs font-normal text-muted-foreground" aria-label="Regular total" style="text-decoration:line-through">' + money(compare) + '</s>' : '') +
              '<span>' + o.price + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    var extraPouch = cart.items.filter(function (it) { return String(it.variant_id) === EXTRA_POUCH; })[0];
    var hasFreePouch = cart.items.some(function (it) { return String(it.variant_id) === FREE_POUCH; });
    var extraQty = extraPouch ? extraPouch.quantity : 0;
    /* Products first, free gifts after them (as in the Amboras bag). */
    var paidRows = [], giftRows = [];
    cart.items.forEach(function (it, i) {
      var line = i + 1;
      if (hasFreePouch && String(it.variant_id) === EXTRA_POUCH) return;
      if (it.handle === CREAM_HANDLE) {
        var n = it.quantity, p = creamPaid(n), f = n - p;
        var step = 'data-line="' + line + '" data-qty="' + n + '" data-cream-step';
        paidRows.push(row(it, {
          remove: line,
          qty: stepper(step + '="-1"', step + '="1"', p, p <= 1, p >= CREAM_MAX_PAID),
          compare: comparisonUnit(it) * p,
          price: money(it.final_line_price)
        }));
        if (f > 0) paidRows.push(row(it, { free: true, qty: qtyNote(f), compare: comparisonUnit(it) * f, price: FREE_PRICE }));
        return;
      }
      if (String(it.variant_id) === FREE_POUCH) {
        giftRows.push(row(it, {
          free: true, remove: line, gift: String(it.variant_id),
          qty: stepper('data-pouch-dec data-extra="' + extraQty + '"', 'data-pouch-inc data-extra="' + extraQty + '"', 1 + extraQty, !extraQty, false),
          compare: comparisonTotal(it) + (extraPouch ? comparisonTotal(extraPouch) : 0),
          current: extraPouch ? extraPouch.final_line_price : 0,
          price: extraQty ? money(extraPouch.final_line_price) + '<span class="block text-[11px] font-normal text-muted-foreground">1 free + ' + extraQty + ' &times; ' + money(extraPouch.final_price) + '</span>' : FREE_PRICE
        }));
        return;
      }
      if (it.final_price === 0) { giftRows.push(row(it, { free: true, remove: line, gift: ALL_GIFTS.indexOf(String(it.variant_id)) !== -1 ? String(it.variant_id) : null, qty: qtyNote(it.quantity), price: FREE_PRICE })); return; }
      paidRows.push(row(it, {
        remove: line,
        qty: stepper('data-line-dec="' + line + '" data-qty="' + it.quantity + '"', 'data-line-inc="' + line + '" data-qty="' + it.quantity + '"', it.quantity, false, false),
        price: money(it.final_line_price)
      }));
    });
    lines.innerHTML = paidRows.concat(giftRows).join('');
  }

  /* ---------------- product: bundle selection + add to cart ---------------- */
  function product() {
    var root = $('[data-product-root]');
    if (!root) return;
    var buttons = $$('[data-bundle-btn]', root);
    if (!buttons.length) return;
    var current = null;
    buttons.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') current = b.dataset.bundleIndex; });
    if (current === null) current = '0';

    function paint(index) {
      current = String(index);
      buttons.forEach(function (b) {
        var on = b.dataset.bundleIndex === current;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        swap(b, on ? SEL.idleBtn : SEL.selectedBtn, on ? SEL.selectedBtn : SEL.idleBtn);
        var dot = b.querySelector('span.h-5.w-5');
        if (dot) {
          swap(dot, on ? SEL.idleDot : SEL.selectedDot, on ? SEL.selectedDot : SEL.idleDot);
          dot.innerHTML = on ? CHECK : '';
        }
      });
      syncSticky();
      $$('[data-perk-unlock]', root).forEach(function (t) {
        var open = Number(current) >= Number(t.dataset.perkUnlock);
        if (t.dataset.perkShippingMinimum) {
          var selected = buttons.filter(function (button) { return button.dataset.bundleIndex === current; })[0];
          var currency = window.Shopify && window.Shopify.currency;
          var rate = currency && currency.active !== 'USD' ? (parseFloat(currency.rate) || 1) : 1;
          var subtotal = Number(selected && selected.dataset.shippingSubtotal);
          if (root.hasAttribute('data-soap-base')) {
            var quantity = Number(selected && selected.dataset.qty) || 1;
            var discounts = { 1: 1000, 3: 1564, 5: 1716 };
            subtotal = Math.max(0, Number(root.dataset.soapBase) - Math.round((discounts[quantity] || 0) * rate)) * quantity;
          }
          open = Number.isFinite(subtotal) && subtotal >= Math.round(Number(t.dataset.perkShippingMinimum) * rate);
        }
        swap(t, open ? 'border-border bg-background/50 opacity-60' : 'border-accent/50 bg-background', open ? 'border-accent/50 bg-background' : 'border-border bg-background/50 opacity-60');
        var b = t.querySelector('[data-perk-badge]');
        if (b) {
          swap(b, open ? 'bg-muted-foreground/60 text-background' : 'bg-accent text-accent-foreground', open ? 'bg-accent text-accent-foreground' : 'bg-muted-foreground/60 text-background');
          b.textContent = open ? (t.dataset.badgeOn || 'Free Bonus') : 'Locked';
        }
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { paint(b.dataset.bundleIndex); });
    });
    var bar = $('[data-sticky-bar]');
    function syncSticky() {
      if (!bar) return;
      var card = buttons.filter(function (b) { return b.dataset.bundleIndex === current; })[0];
      if (!card) return;
      var spans = $$('span', card);
      var name = card.querySelector('.leading-tight');
      var badge = spans.filter(function (x) { return x.className.indexOf('rounded bg-[#315d3e]') === 0; })[0];
      var price = card.querySelector('.text-lg'), compare = card.querySelector('.line-through');
      var unit = spans.filter(function (x) { return x.className.indexOf('text-[11px]') !== -1 && x.className.indexOf('font-bold') !== -1; })[0];
      function put(sel, txt) { var n = $(sel, bar); if (n && txt) n.textContent = txt.replace(/\s+/g, ' ').trim(); }
      put('[data-sticky-label]', (name ? name.textContent : '') + (badge ? ' \u00b7 ' + badge.textContent : ''));
      put('[data-sticky-price]', price && price.textContent);
      put('[data-sticky-compare]', compare && compare.textContent);
      put('[data-sticky-unit]', unit && unit.textContent);
    }
    if (bar) {
      var inline = $$('[data-add-to-cart]', root).filter(function (b) { return !bar.contains(b); });
      var first = inline[0], last = inline[inline.length - 1];
      var barBtn = $('[data-add-to-cart]', bar);
      var showing = false, tick = 0;
      var check = function () {
        tick = 0;
        var past = first && first.getBoundingClientRect().bottom < 0;
        var r = last && last !== first ? last.getBoundingClientRect() : null;
        var lastVisible = r && r.top < window.innerHeight && r.bottom > 0;
        var show = !!(past && !lastVisible);
        if (show === showing) return;
        showing = show;
        swap(bar, show ? 'pointer-events-none translate-y-full opacity-0' : 'translate-y-0 opacity-100', show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0');
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = show ? 0 : -1;
      };
      if (barBtn) barBtn.tabIndex = -1;
      window.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(check); }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }

    paint(current);

    $$('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var active = buttons.filter(function (b) { return b.dataset.bundleIndex === current; })[0];
        var id = (active && active.dataset.variantId) || root.dataset.defaultVariant;
        if (!id) return;
        restartReservation();
        btn.disabled = true;
        var label = btn.innerHTML;
        btn.innerHTML = SPINNER + 'Adding\u2026';
        var done = function () { btn.disabled = false; btn.innerHTML = label; };
        addCartItems([{ id: Number(id), quantity: Number(active && active.dataset.qty) || 1 }])
          .then(function (cart) { done(); openCart(cart); })
          .catch(function () { btn.disabled = false; btn.innerHTML = 'Could not add \u2013 please try again'; setTimeout(function () { btn.innerHTML = label; }, 2500); });
      });
    });
  }

  /* ---------------- product gallery ---------------- */
  function openLightbox(src, alt, back) {
    var box = document.createElement('div');
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Enlarged product image');
    box.style.cssText = 'position:fixed;inset:0;z-index:60;background:rgba(20,26,22,.88);display:flex;align-items:center;justify-content:center;padding:16px;cursor:zoom-out';
    box.innerHTML = '<img alt="" style="max-width:min(92vw,900px);max-height:88vh;border-radius:16px;object-fit:contain;background:#fffdf8"><button type="button" aria-label="Close larger image" style="position:absolute;top:16px;right:16px;width:44px;height:44px;border-radius:9999px;background:#fffdf8;color:#243128;font-size:28px;line-height:1">&times;</button>';
    var im = box.querySelector('img'); im.src = src; im.alt = alt || '';
    function close() { box.remove(); document.removeEventListener('keydown', onKey); document.documentElement.style.overflow = ''; if (back) back.focus(); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    box.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.appendChild(box);
    document.documentElement.style.overflow = 'hidden';
    box.querySelector('button').focus();
  }
  function gallery(){if(document.querySelector('[data-cream-clone-root], [data-catalog-product], [data-shipping-service]'))return;
    function num(el) { return Number((el.getAttribute('aria-label').match(/\d+/) || [1])[0]); }
    function mark(list, n) {
      list.forEach(function (o) {
        var on = num(o) === n;
        swap(o, on ? 'border-border' : 'border-[#315d3e]', on ? 'border-[#315d3e]' : 'border-border');
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    /* desktop: big image + thumbnail row */
    var main = $('[aria-label="Open larger image"]');
    var mainImg = main && main.querySelector('img');
    var desk = main && main.nextElementSibling ? $$('button[aria-label^="Show image"]', main.nextElementSibling) : [];
    desk.forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.querySelector('img');
        if (mainImg && img) { mainImg.src = img.getAttribute('src'); mainImg.alt = (img.alt || '').replace(' thumbnail', ' \u2014 image'); }
        mark(desk, num(t));
      });
    });
    if (main && mainImg) main.addEventListener('click', function () { openLightbox(mainImg.currentSrc || mainImg.src, mainImg.alt, main); });
    /* mobile: swipe track + arrows + thumbnails */
    var prev = $('[aria-label="Previous image"]'), next = $('[aria-label="Next image"]');
    var track = $('.snap-mandatory');
    if (!prev || !next || !track) return;
    var slides = Array.prototype.slice.call(track.children);
    var mob = prev.nextElementSibling ? $$('button[aria-label^="Show image"]', prev.nextElementSibling) : [];
    var cur = 0, frame = 0;
    function pos(i) {
      var sl = slides[i];
      return Math.max(0, sl.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - (track.clientWidth - sl.clientWidth) / 2);
    }
    function state(i) {
      cur = Math.max(0, Math.min(slides.length - 1, i));
      prev.disabled = cur === 0; next.disabled = cur === slides.length - 1;
      mark(mob, cur + 1);
      var t = mob[cur];
      if (t && t.parentElement) { var p = t.parentElement; var l = t.offsetLeft - p.offsetLeft; if (l < p.scrollLeft || l + t.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollLeft = l - (p.clientWidth - t.offsetWidth) / 2; }
    }
    function go(i) { state(i); track.scrollTo({ left: pos(cur), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur + 1); });
    mob.forEach(function (t) { t.addEventListener('click', function () { go(num(t) - 1); }); });
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var best = 0;
        slides.forEach(function (sl, i) { if (Math.abs(pos(i) - track.scrollLeft) < Math.abs(pos(best) - track.scrollLeft)) best = i; });
        if (best !== cur) state(best);
      });
    }, { passive: true });
    slides.forEach(function (sl, i) {
      var img = sl.querySelector('img');
      if (img) { sl.style.cursor = 'zoom-in'; sl.addEventListener('click', function () { openLightbox(img.currentSrc || img.src, img.alt, sl); }); }
    });
    state(0);
  }

  /* Soap tiers are fixed USD discounts that Shopify converts at the live rate, so in other
     currencies the card prices are recomputed the same way the cart does it. */
  function soapLocalPrices() {
    var root = $('[data-soap-base]'), cur = window.Shopify && window.Shopify.currency;
    if (!cur || cur.active === 'USD') return;
    $$('[data-soap-card]').forEach(function (n) {
      var b = Number(n.dataset.base), u = b - Math.round(1000 * (parseFloat(cur.rate) || 1));
      var p = $('[data-card-price]', n), sv = $('[data-card-save]', n);
      if (p) p.textContent = money(u);
      if (sv) sv.textContent = money(b - u);
    });
    $$('[data-soap-from]').forEach(function (n) { n.textContent = money(Number(n.dataset.base) - Math.round(1896 * (parseFloat(cur.rate) || 1))); });
    if (!root) return;
    var rate = parseFloat(cur.rate) || 1, base = Number(root.dataset.soapBase), off = { 1: 1000, 3: 1564, 5: 1716 };
    Object.keys(off).forEach(function (q) {
      var unit = base - Math.round(off[q] * rate);
      $$('[data-soap-unit="' + q + '"]').forEach(function (n) { n.textContent = money(unit); });
      $$('[data-soap-price="' + q + '"]').forEach(function (n) { n.textContent = money(unit * Number(q)); });
      $$('[data-soap-save="' + q + '"]').forEach(function (n) { n.textContent = money((base - unit) * Number(q)); });
    });
  }

  var SPINNER = '<svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" opacity=".25"></circle><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path></svg>';

  /* Checkout can take a few seconds to open, so show it is working. */
  function checkoutButtons() {
    $$('[data-checkout-btn]').forEach(function (a) {
      var label = null;
      a.addEventListener('click', function () {
        if (label !== null) return;
        label = a.innerHTML;
        a.innerHTML = '<span style="display:inline-flex;align-items:center;justify-content:center;gap:10px">' + SPINNER + '<span>Opening</span></span>';
      });
      window.addEventListener('pageshow', function () { if (label !== null) { a.innerHTML = label; label = null; } });
    });
  }

  function manageCookies() {
    var dialog = $('[data-privacy-dialog]');
    if (!dialog) return;
    var opener = null, consent = null, allowed = false, pending = false;
    var choice = $('[data-privacy-choice]', dialog), status = $('[data-privacy-message]', dialog);
    function say(text) { status.textContent = text; }
    function gpc() { return !!(window.navigator && window.navigator.globalPrivacyControl); }
    function paint() {
      allowed = !!(consent && (consent.analyticsProcessingAllowed() || consent.marketingAllowed() || consent.saleOfDataAllowed()));
      say(gpc() ? 'Your browser privacy signal is on, so tracking is off for you.' : allowed ? 'Tracking is currently on.' : 'You have opted out. Tracking is off.');
      choice.textContent = allowed ? 'Opt out' : 'Turn tracking back on';
      choice.hidden = !allowed && gpc(); choice.style.display = choice.hidden ? 'none' : ''; choice.disabled = false;
    }
    function close() {
      dialog.classList.add('hidden'); document.documentElement.style.overflow = '';
      if (opener && opener.isConnected) opener.focus();
    }
    function load(done) {
      function ready(error) {
        consent = window.Shopify && window.Shopify.customerPrivacy;
        if (error || !consent || typeof consent.setTrackingConsent !== 'function') {
          say('Privacy settings are temporarily unavailable. Please contact support@try-evelyns.com.'); choice.disabled = true; return;
        }
        try { done(); } catch (error) { say('Privacy settings are temporarily unavailable. Please contact support@try-evelyns.com.'); choice.disabled = true; }
      }
      if (window.Shopify && window.Shopify.customerPrivacy) ready();
      else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], ready); } catch (error) { ready(error); }
      }
      else ready(true);
    }
    $$('[data-manage-cookies]').forEach(function (button) {
      button.addEventListener('click', function () {
        opener = button; dialog.classList.remove('hidden'); document.documentElement.style.overflow = 'hidden';
        choice.disabled = true; choice.style.display = ''; say('Loading your privacy choices…');
        $('[data-privacy-close]', dialog).focus(); load(paint);
      });
    });
    $$('[data-privacy-close]', dialog).forEach(function (button) { button.addEventListener('click', close); });
    choice.addEventListener('click', function () {
      if (!consent || pending || (!allowed && gpc())) return;
      var value = !allowed; pending = true; choice.disabled = true; say('Saving your privacy preference…');
      try { consent.setTrackingConsent({ analytics: value, marketing: value, sale_of_data: value }, function (result) {
        pending = false;
        if (result && result.error) { choice.disabled = false; say('Your preference could not be saved. Please try again.'); return; }
        var footerStatus = $('[data-privacy-status]');
        if (footerStatus) footerStatus.textContent = value ? 'Your privacy preference has been saved for this browser.' : 'Your opt-out preference has been saved for this browser.';
        close();
      }); } catch (error) { pending = false; choice.disabled = false; say('Your preference could not be saved. Please try again.'); }
    });
    document.addEventListener('keydown', function (event) {
      if (dialog.classList.contains('hidden')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var buttons = $$('button:not([disabled])', dialog).filter(function (button) { return button.offsetParent !== null; });
      var first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

function init() {
    countdown(); headerScroll(); mobileMenu(); cartDrawer(); product(); gallery(); soapLocalPrices(); checkoutButtons(); manageCookies();
    if ($('[data-cart-drawer]')) refreshCart().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
